// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3QLJT","dragIcon":"Choice_dragIcon__cF00D","left":"Choice_left__3ORP_","input":"Choice_input__QdvOL"};